module.exports = __webpack_public_path__ + "img/Fruits-secs.79c7a230.svg";